import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers"
import CategoryHero from "../ones/CategoryHero"
import Footer from "../ones/Footer"
import OneBook from "../ones/OneBook"

export default function BooksLanding() {

  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await Promise.all([
      appContext.getAllBooks(),
    ])
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [])

  if (ready) {
    const records = appContext.allBooks || [];

    return (
      <>
        <CategoryHero
          eyebrow="MIKA KENYATA BOOKS"
          title="Find your next great read."
          description="Explore published books from the Mika Kenyata marketplace."
        />

        <div className="container marketplace-page-container">
          <h6 className="main-section-title">Books</h6>
          <div className="row g-4">
            {
              records.length > 0 ?
                records.map((item) => {
                  return (
                    <div className="col-12 col-sm-6 col-lg-4" key={item.uuid}>
                      <OneBook data={item} />
                    </div>
                  )
                })
                :
                <div className="col-12">
                  <div className="marketplace-empty-state">No books were found</div>
                </div>
            }
          </div>
        </div>

        <Footer />
      </>
    )
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
